// extracted by mini-css-extract-plugin
export var signupForm = "SignupForm-module--signupForm--1Pr48";
export var subscriptionSent = "SignupForm-module--subscriptionSent--1K_SV";
export var content = "SignupForm-module--content--3Q0Yy";
export var signupInput = "SignupForm-module--signupInput--OMxlF";